import React, { useState, useEffect, useCallback, useContext } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, IconButton,
  Dialog, DialogActions, DialogContent, DialogTitle, TextField, Box, CircularProgress, Typography,
  Select, MenuItem, FormControl, InputLabel,
  Grid
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { deviceApi, storeApi, deviceGroupApi, deviceTypeApi } from '../../apiUser';
import { InfoContext } from '../../context/InfoContext';
import SelectBox from '../../components/SelectBox';

const Devices = () => {
  const [devices, setDevices] = useState([]);
  const [deviceGroups, setDeviceGroups] = useState([]);
  const [deviceTypes, setDeviceTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [openForm, setOpenForm] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [currentDevice, setCurrentDevice] = useState(null);
  const [stores, setStores] = useState([]);
  const {info, setInfo} = useContext(InfoContext);
  



  useEffect(() => {
    fetchInfos();
  }, []);

  const fetchInfos = async () => {
    setLoading(true);
    try {
      const _devices = await deviceApi.get(info.selectedClient.client_id);
      const _stores = await storeApi.get(info.selectedClient.client_id);
      const _deviceGroups = await deviceGroupApi.get(info.selectedClient.client_id);
      const _deviceTypes = await deviceTypeApi.get(info.selectedClient.client_id);
      console.log('Fetched Devices:', _devices.data);
      console.log('Fetched Stores:', _stores.data);
      console.log('Fetched Device Groups:', _deviceGroups.data);
      console.log('Fetched Device Types:', _deviceTypes.data);

      if (_deviceGroups !== undefined) {
        setDeviceGroups(_deviceGroups.data);
      }
      if (_deviceTypes !== undefined) {
        setDeviceTypes(_deviceTypes.data);
      }
      if (_stores !== undefined) {
        setStores(_stores.data);
      }
      if (_devices !== undefined) {
        setDevices(_devices.data);
      }
    } catch (err) {
      setError(err.message || 'Errore durante il caricamento dei dispositivi');
    } finally {
      setLoading(false);
    }
  }

  const handleCreate = async (device) => {
    setLoading(true);
    try {
      if (currentDevice) {
        // Create new device
        deviceApi.create(info.selectedClient.client_id, currentDevice);
        await fetchInfos();
      }
    } catch (err) {
      setError(err.message || 'Errore durante la creazione del dispositivo');
    } finally {
      setLoading(false);
      setOpenForm(false);
    }
  };

  const handleOpenForm = () => {
    setCurrentDevice(null);
    setOpenForm(true);
  };
  const handleOpenEdit = (group) => {
    setCurrentDevice(group);
    setOpenForm(true);
  }
  const handleOpenDelete = (device) => {
    setCurrentDevice(device);
    setOpenDelete(true);
  };


  return(
    <Box sx={{ padding: 2 }}>
      <Grid container spacing={2}>
        <Grid item size={{xs: 12, sm: 6, md: 4}}>
          <Typography variant="h4" gutterBottom>
            Dispositivi
          </Typography>
        </Grid>
        <Grid item size={{xs: 12, sm: 6, md: 8}} display="flex" justifyContent="flex-end">
          <Button variant="contained" color="primary" onClick={() => handleOpenForm()}>
            Aggiungi Dispositivo
          </Button>
        </Grid>
        <Grid item size={{ xs: 12 }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Descrizione</TableCell>
                  <TableCell>Negozio</TableCell>
                  <TableCell>Gruppo Dispositivi</TableCell>
                  <TableCell>Tipo Device</TableCell>
                  <TableCell>Azioni</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {devices.map((device) => (
                  <TableRow key={device.id}>
                    <TableCell>{device.id}</TableCell>
                    <TableCell>{device.description}</TableCell>
                    <TableCell>{device.store?.description || 'N/A'}</TableCell>
                    <TableCell>{device.group?.description || 'N/A'}</TableCell>
                    <TableCell>{device.type?.description || 'N/A'}</TableCell>
                    <TableCell>
                      <IconButton onClick={() => handleOpenEdit(device)}>
                        <EditIcon />
                      </IconButton>
                      <IconButton onClick={() => handleOpenDelete(device)}>
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      <Dialog open={openForm} onClose={() => setOpenForm(false)}>
        <DialogTitle>{currentDevice ? 'Modifica Dispositivo' : 'Aggiungi Dispositivo'}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="ID"
            type="text"
            fullWidth
            value={currentDevice ? currentDevice.id : ''}
            onChange={(e) => setCurrentDevice({ ...currentDevice, id: e.target.value })}
          />
          <TextField
            autoFocus
            margin="dense"
            label="Descrizione"
            type="text"
            fullWidth
            value={currentDevice ? currentDevice.description : ''}
            onChange={(e) => setCurrentDevice({ ...currentDevice, description: e.target.value })}
          />
          <TextField
            autoFocus
            margin="dense"
            label="Categoria"
            type="text"
            fullWidth
            value={currentDevice ? currentDevice.category : ''}
            onChange={(e) => setCurrentDevice({ ...currentDevice, category: e.target.value })}
          />
          <SelectBox
            options={stores.map(store => ({ key: store.id, value: store.description }))}
            onSelectionChange={(selected) => setCurrentDevice({ ...currentDevice, store_id: selected[0]?.key })}
            // Pass the derived value directly as the 'initialSelected' prop.
            // SelectBox's internal useEffect will handle updating the display when this prop changes.
            initialSelected={stores.filter(n => n.id === currentDevice?.store_id).map(store => ({ key: store.id, value: store.description }))}
            label="Negozio" // The SelectBox component expects a label prop.
          />
          <SelectBox
            options={deviceGroups.map(group => ({ key: group.id, value: ` ${group.id} - ${group.description}` }))}
            onSelectionChange={(selected) => setCurrentDevice({ ...currentDevice, group_id: selected[0]?.key })}
            initialSelected={deviceGroups.filter(n => n.id === currentDevice?.group_id).map(group => ({ key: group.id, value: group.description }))}
            label="Gruppo Dispositivi" // The SelectBox component expects a label prop.
          />
          <SelectBox
            options={deviceTypes.map(type => ({ key: type.id, value: type.description }))}
            onSelectionChange={(selected) => setCurrentDevice({ ...currentDevice, type_id: selected[0]?.key })}
            initialSelected={deviceTypes.filter(n => n.id === currentDevice?.type_id).map(type => ({ key: type.id, value: type.description }))}
            label="Tipo Dispositivo" // The SelectBox component expects a label prop.
          />
          
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenForm(false)} color="primary">
            Annulla
          </Button>
          <Button onClick={() => handleCreate(currentDevice)} color="primary">
            {currentDevice ? 'Salva' : 'Crea'}
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  )


}

export default Devices;